import { Currency as BillingCurrency, Frequency as BillingFrequency } from '@galaxy/billing';
import { Frequency as GalaxyFrequency } from '@vendasta/galaxy/frequency';
import {
  CurrenciesCurrency as PackagesCurrency,
  FrequenciesFrequency as PackagesFrequency,
} from '@vendasta/marketplace-packages';
import { UnitBillingFrequency as AppsFrequency } from '@galaxy/marketplace-apps';

export function convertPackagesCurrencyToString(currency: PackagesCurrency): string {
  return PackagesCurrency[currency];
}

export function convertBillingCurrencyToString(currency: BillingCurrency): string {
  return BillingCurrency[currency];
}

export function convertAppsFrequencyToGalaxyFrequency(frequency: AppsFrequency): GalaxyFrequency {
  switch (frequency) {
    case AppsFrequency.UNIT_BILLING_FREQUENCY_ONETIME:
      return GalaxyFrequency.ONE_TIME;
    case AppsFrequency.UNIT_BILLING_FREQUENCY_YEARLY:
      return GalaxyFrequency.YEARLY;
    default:
      return GalaxyFrequency.MONTHLY;
  }
}

export function convertPackageFrequencyToGalaxyFrequency(frequency: PackagesFrequency): GalaxyFrequency {
  switch (frequency) {
    case PackagesFrequency.ONCE:
      return GalaxyFrequency.ONE_TIME;
    case PackagesFrequency.YEARLY:
      return GalaxyFrequency.YEARLY;
    default:
      return GalaxyFrequency.MONTHLY;
  }
}

export function convertGalaxyFrequencyToPackageFrequency(frequency: GalaxyFrequency): PackagesFrequency {
  switch (frequency) {
    case GalaxyFrequency.ONE_TIME:
      return PackagesFrequency.ONCE;
    case GalaxyFrequency.YEARLY:
      return PackagesFrequency.YEARLY;
    default:
      return PackagesFrequency.MONTHLY;
  }
}

export function convertBillingFrequencyToGalaxyFrequency(frequency: BillingFrequency): GalaxyFrequency {
  switch (frequency) {
    case BillingFrequency.OneTime:
      return GalaxyFrequency.ONE_TIME;
    case BillingFrequency.Yearly:
      return GalaxyFrequency.YEARLY;
    default:
      return GalaxyFrequency.MONTHLY;
  }
}

export function convertStringFrequencyToGalaxyFrequency(frequency: string): GalaxyFrequency {
  switch (frequency) {
    case 'once':
      return GalaxyFrequency.ONE_TIME;
    case 'yearly':
      return GalaxyFrequency.YEARLY;
    default:
      return GalaxyFrequency.MONTHLY;
  }
}
